module.exports = __webpack_public_path__ + "static/media/icon-especialidade.033625f4.svg";